export function numberToPercentWithFixedFractionDigits(value: number, fractionDigits: number) {
  if (!isNaN(value)) {
    return parseFixedFractionDigits(value / 100, fractionDigits);
  } else {
    return undefined;
  }
}

export function parseFixedFractionDigits(value: number, fractionDigits: number) {
  if (!isNaN(value)) {
    return value.toFixed(fractionDigits);
  } else {
    return undefined;
  }
}
